import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useLocalePath, useT } from "../i18n";
import { MAIN_NAV } from "../config/navigation";
import { Logo } from "./Logo";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { MobileMenu } from "./MobileMenu";

const useScrolled = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return scrolled;
};

export const Header = () => {
  const t = useT();
  const lp = useLocalePath();
  const scrolled = useScrolled();
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const solid = scrolled || open;
  return (
    <>
      <header
        data-testid="site-header"
        data-solid={solid}
        className={`fixed inset-x-0 top-0 z-50 text-white transition-[background-color,border-color] duration-500 ${
          solid ? "border-b border-white/10 bg-ink/95 backdrop-blur-xl" : "border-b border-transparent bg-transparent"
        }`}
      >
        <div className="container-x flex h-[72px] items-center justify-between lg:h-20">
          <Link to={lp()} aria-label="HAROON TRADING" data-testid="header-logo-link">
            <Logo tone="light" />
          </Link>
          <nav className="hidden items-center gap-8 xl:flex 2xl:gap-10" aria-label="Main">
            {MAIN_NAV.map((key) => (
              <NavLink key={key} to={lp(key)} data-testid={`nav-${key}`} className={({ isActive }) => `nav-link ${isActive ? "is-active" : ""}`}>
                {t(`nav.${key}`)}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3 sm:gap-6">
            <LanguageSwitcher id="header" />
            <button
              type="button"
              onClick={() => setOpen((o) => !o)}
              aria-expanded={open}
              aria-label={open ? t("ui.close") : t("ui.menu")}
              data-testid="mobile-menu-toggle"
              className="group relative -mr-2.5 flex h-11 w-11 items-center justify-center xl:hidden"
            >
              <span className={`absolute h-px w-6 bg-white transition-transform duration-500 ${open ? "rotate-45" : "-translate-y-[4px]"}`} />
              <span className={`absolute h-px bg-white transition-[transform,width] duration-500 ${open ? "w-6 -rotate-45" : "w-4 translate-x-1 translate-y-[4px]"}`} />
            </button>
          </div>
        </div>
      </header>
      <MobileMenu open={open} />
    </>
  );
};
